import { motion } from 'framer-motion';
import { LuArrowRight } from 'react-icons/lu';
import { Card } from '../../../design-system/components';
import LinkButton from '../components/LinkButton';
import { LandingHeader } from '../components/SectionHeading';
import { trackUserEvent } from '../../../utils/reddit-pixel';

export default function QuizCTASection() {
  return (
    <section id="quiz" className="ee-landing-section">
      <motion.div
        className="ee-landing-container ee-landing-container--narrow"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Card padding="lg" tone="warm" className="ee-landing-cta">
          <div className="ee-landing-cta__emoji">🔮</div>
          <LandingHeader
            title="What's Your Relationship Superpower?"
            subtitle="Take our free 3-minute quiz to discover your unique relationship superpower — and learn how to use it to deepen your connections."
          />
          <div className="ee-landing-cta__actions">
            <LinkButton
              to="/quiz-assessment"
              size="lg"
              onClick={() => trackUserEvent('Custom', { customEventName: 'ClickQuizCTA' })}
              trailingIcon={<LuArrowRight />}
            >
              Take the Free Quiz
            </LinkButton>
          </div>
          <p className="ee-landing-cta__fine">No account required. Takes 3 minutes.</p>
        </Card>
      </motion.div>
    </section>
  );
}
